import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'

// Import Libraries
import { Link } from 'react-router-dom'

// Import Styles
import styles from './styles/JobCard.module.css'

const JobCard2 = () => {
  return (
    <Card className={styles.jobs__card}>
      <Card.Body>
        <Card.Title className='mb-0'>
          <b>Mobile Developer</b>
        </Card.Title>
        <div className='mt-4 mb-4'>
          <h6 className='mb-2'>
            <b>Description</b>
          </h6>
          <p>
            We are looking for a Python (Django) developer who will be
            responsible for developing server-sid
          </p>
          <Link to='/job-detail'>
            <b>Read More</b>
          </Link>
        </div>
        <hr />
        <div className='mt-4'>
          <h6 className='mb-4'>
            <b>Required Skills</b>
          </h6>
          <Row>
            <Col md={6}>Python</Col>
            <Col md={6} style={{ textAlign: 'right' }}>
              <b className='rate__skill_link'>Rate Skill</b>
            </Col>
          </Row>
          <Row>
            <Col md={6}>React</Col>
            <Col md={6} style={{ textAlign: 'right' }}>
              <b className='rate__skill_link'>Rate Skill</b>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  )
}

export default JobCard2
